import {
	Box,
	Select,
	Typography,
	type BoxProps,
	type SelectProps,
	type TypographyProps,
} from '@mui/material'
import { blue } from '@mui/material/colors'
import { styled } from '@mui/material/styles'
import { type ComponentType } from 'react'

export const SmallSelect: ComponentType<SelectProps> = styled( Select )<SelectProps>( ( ) => ( {
	'height': '34px',

	'.MuiSelect-icon': {
		color: blue.A700, // Customize this color as needed
	},
} ) )

export const SelectPlaceholder: ComponentType<BoxProps> = styled( Box )( ( ) => ( {
	display: 'flex',
	alignItems: 'center',
	color: blue.A700,
} ) )

export const SelectedText: ComponentType<TypographyProps> = styled( Typography )( ( ) => ( {
	color: blue.A700,
} ) )
